<template>

<v-layout  row  wrap >
<v-flex>

<v-card>

<v-tabs v-if="init.network.processName == 'filter'" dark color="#F5F5F5" show-arrows height="30px">
<v-tabs-slider color="#5181B8"></v-tabs-slider>

<div v-for="item in init.menu.items">
<v-tab :id="item.id" @click="changeForm(item.form, item.objName, item.dataType)"  >
<span style="color:#707070;font-weight:bold"> {{item.title}}  </span>
</v-tab>
</div>

<v-spacer> </v-spacer>
</v-tabs>

<b-tabs  v-else  >
<div v-for="item in init.menu.items">
<b-tab :id="item.id" @click="changeForm(item.form, item.objName, item.dataType)"  >
<span  slot="title"> {{item.title}}  </span>
</b-tab>
</div>
</b-tabs>






<v-card-title>
<span  style="color:gray;font-size:1.2em; margin:5px" v-if="ui.parsing">Выполняется поиск   </span>   <span style="color:#A7A7A7;font-size:1.2em;margin:5px" v-if="!ui.parsing"> {{init.title.first}} </span> <span  style="color:gray;font-size:1.3em"  > {{foundData.foundIds.length}} </span>
<v-spacer> </v-spacer>
<v-btn style="text-transform:none"   small flat   v-if="proccessId !== null" @click="toSave = true"   >
<v-icon  left  color="green">mdi-content-save</v-icon>
Сохранить
</v-btn>
<v-btn style="text-transform:none"   small flat  v-if="proccessId !== null"   @click="clearResult()"    >
<v-icon  left  color="red">mdi-delete-forever</v-icon>
Очистить
</v-btn>
</v-card-title>



<v-layout  >
<div style="width:550px;min-width:550px;min-height:100vh; border:solid #E3E4E8 1px; margin-left:15px;margin-bottom:15px;border-radius:3px">


      <div  v-if="init.searchLoop.active"   >



        <v-text-field
        @keyup.enter="sendForm()"
        box
        v-model='q'
        :placeholder="init.searchLoop.placeholder"
        hint="введите ключевые фразы через запятую"
        >
        <v-fade-transition
          slot="append"
          leave-absolute
        >
          <v-icon   @click="sendForm()" large  > mdi-magnify </v-icon>
        </v-fade-transition>
        </v-text-field>
        </div>



        <div v-if="foundData.foundIds.length == 0" style="margin: 30px auto 30px; padding:15px" >
        <div class="text-xs-center">
        <p style="font-size:1.3em; color:#858585">{{init.beforeSearch.title}}. </p>
        <p v-if="ui.parsing" style="font-size:1.3em; color:#858585">Сохраните текущую задачу как процесс. </p>

        </div>

        <div  v-if="ui.parsing" class="text-xs-center">
          <v-btn   small flat   v-if="proccessId !== null" @click=" toSave = true"   >
            <v-icon  left  color="green">mdi-content-save</v-icon>
            Сохранить процесс
         </v-btn>
         <v-btn   small flat  v-if="proccessId !== null"   @click="clearResult()"    >
           <v-icon  left  color="red">mdi-delete-forever</v-icon>
           Отменить
        </v-btn>
        </div>

        <div  v-if="init.beforeSearch.activator" class="text-xs-center">
          <v-btn
            :disabled="ui.parsing"
            :loading="ui.parsing"
            class="white--text"
            color="#4A76A8"
             @click="sendForm()"
          >
           {{init.beforeSearch.activatorName}}
          </v-btn>
        </div>


     <div v-if="init.progressСircular">
        <div v-if="ui.parsing   " class="text-xs-center" style="marginTop:50px;marginBottom:15px;" >

          <v-progress-circular
            :size="70"
            :width="7"
            color="#4A76A8"
            indeterminate
          ></v-progress-circular>

        </div>
      </div>
        </div>


   <app-page-template v-if="init.network.dataType =='pages'"   :foundData='foundData'> </app-page-template>
   <app-group-template v-if="init.network.dataType =='groups'" :foundData='foundData'> </app-group-template>
   <app-video-template v-if="init.network.dataType =='videos'" :foundData='foundData'> </app-video-template>
   <app-topic-template v-if="init.network.dataType =='topics'" :foundData='foundData'> </app-topic-template>
   <app-post-template v-if="init.network.dataType =='posts'" :foundData='foundData'> </app-post-template>

</div>





<v-flex    v-if="this.foundData.foundIds.length > 0"  style="max-width:600px ;margin-left:20px; margin-right:15px">

<app-meneger    v-sticky sticky-offset="stickyOffset"    :contentMenegment="init.contentMenegment" :foundData="foundData"></app-meneger>

</v-flex>



<v-flex  style="max-width:600px" v-if="this.foundData.foundIds.length <= 0">
      <div style="margin-left:15px;margin-right:15px;border:solid #E3E4E8 1px;padding:5px;max-height:100vh;min-height:100vh;overflow-y:auto;border-radius:3px">

         <div   v-for="item in this.init.forma">


        <div v-if="item.type =='useMemoryItems' && item.memoryCounter > 0">
          <v-checkbox :label="item.label" v-model="item.vModel.value">  </v-checkbox>
        </div>




           <div v-if="item.type =='select-country'">
             <v-select
               color="#4A76A8"
               v-model="item.vModel.value"
               :items="item.options"
               v-bind='[{label:item.name} ]'
             ></v-select>


           <v-autocomplete v-if="item.vModel.value !==''"
                        multiple
                        :loading="loading"
                        v-model="item.vModelCitiesIds.value"
                        hide-no-data
                        :items="citiesVK"
                        :search-input.sync="search"
                        chips
                        color="#4A76A8"
                        label="Город"
                        item-text="title"
                        item-value="id"
                        hide-selected
                      >
           <v-icon slot="append" @click="citySearch()"> mdi-magnify </v-icon>

                      </v-autocomplete>


           </div>






<div v-if="item.type =='checkboxMulti'">
<v-checkbox hide-details  color="#232F3A" @change="item.dialogOpen = true" v-model='item.vModel.value' >
<span style="color:#232F3A;margin-top:6px" slot="label">{{item.name}}</span>
</v-checkbox>
<v-dialog scrollable  width=750 v-model="item.dialogOpen">   <app-checkboxMulti :init="item">  </app-checkboxMulti> </v-dialog>
</div>


<div v-if="item.type =='checkbox'">
<v-checkbox hide-details  color="#232F3A"    v-model='item.vModel.value' >
<span style="color:#232F3A;margin-top:6px" slot="label">{{item.name}}</span>
</v-checkbox>
</div>

         <div v-if="item.type =='select'">
           <v-select
             @change = "changeSelectObj(item)"
             color="#4A76A8"
             v-model="item.vModel.value"
             :items="item.options"
             v-bind='[{label:item.name} ]'
           ></v-select>
         </div>

         <div v-if="item.type =='input'"  >
           <v-text-field         clearable   v-bind='[{label:item.name} ]' v-model='item.vModel.value' > </v-text-field>
         </div>

         <div v-if="item.type =='textarea'">


           <v-textarea    hide-details
           clearable
           color="#4A76A8"
         v-bind='[{label:item.name} ]'
         v-model='item.vModel.value'
         hint="Hint text"
       ></v-textarea>
         </div>

     <div v-if="item.type =='datePicker'">
       <v-menu      absolute full-width :close-on-content-click="false"  v-model="item.modal">
       <v-text-field
                 clearable
                 color="#4A76A8"
                 slot="activator"
                 v-model="item.vModel.value"
                 v-bind='[{label:item.name} ]'

                 readonly
               ></v-text-field>
               <v-date-picker

                v-model="item.vModel.value"
                no-title
                :first-day-of-week="1"
                locale="ru-Latn"
                min="2006-10-10"
                >
                 <v-spacer></v-spacer>
       <v-btn flat color="#4A76A8" @click="item.modal =false">Выбрать</v-btn>
                 </v-date-picker>
       </v-menu>
     </div>


     <div v-if="item.type =='procBinding'">
   <app-procBinding :init="item.vModel"> </app-procBinding>
    </div>



</div>


<v-text-field v-model="token" clearable label="Определенный токен API"></v-text-field>
</div>
</v-flex>









</v-layout>
   </v-card>
</v-flex>




  <v-snackbar
    v-model="sb.snackbar"
    :color="sb.color"
    center top
    :timeout="2000"
  >
    {{ sb.text  }}
    <v-btn
      dark
      flat
      @click="sb.snackbar = false"
    >
      ОК
    </v-btn>
  </v-snackbar>



<v-dialog v-model="toSave" width="550">
  <v-card>
<v-card-text>

<v-text-field v-model="proccessTitle" clearable label="Введите название процесса"> </v-text-field>


<p style="color:#757575;font-size:1.3em"> Через какое время обновлять процесс ?</p>
  <v-layout row>

    <v-flex class="px-3">
      <v-subheader>Минуты</v-subheader>
      <v-slider
      v-model="updateTimer.min"
      max="59"
      color="primary"
      thumb-label="always"
      ></v-slider>
      </v-flex>


     <v-flex class="px-3">
       <v-subheader>Часы</v-subheader>
      <v-slider
      v-model="updateTimer.hours"
      max="23"
      color="primary"
      thumb-label="always"
      ></v-slider>
      </v-flex>


     <v-flex class="px-3">
       <v-subheader>Дни</v-subheader>
      <v-slider
      max="30"
      v-model="updateTimer.days"
      color="primary"
      thumb-label="always"
      ></v-slider>
      </v-flex>

  </v-layout>
<v-textarea v-model="proccessText" label="Краткое описание процесса"></v-textarea>
</v-card-text>
<v-card-actions>
<v-btn @click="save()" block color="primary"> Сохранить процесс </v-btn>
</v-card-actions>

  </v-card>
</v-dialog>




  </v-layout>



</template>

<script>
import axios from 'axios'

export default {
props:['init'],
   data(){
   return{
     stickyOffset: {
       top:75
     },

    token:"",
    toSave : false,
    proccessTitle: "",
    proccessText: "",
    updateTimer: {
      min: 18,
      hours: 0,
      days: 0,

      time: 0,
    },



     sb:{
     snackbar: false,
     color: 'success',
     text: ''
        },

     loading: false,
     search: "+",
     cities:[],
     proccessId: null,

     q:"",
     ui:{
        loadingMore: false,
        parsing: false
     },

     foundData:{
      selector: false,
      foundIds: [],
      displayIds: [],
      selectedIds: [],
      offset: 0,
      selectAll: false
    },




   }
 },
computed:{

  citiesVK(){
    return  this.cities
  },

  procTimer(){
    this.updateTimer.time = (this.updateTimer.min * 60) + (this.updateTimer.hours * 60 * 60) + (this.updateTimer.days * 24 * 60 * 60)
    return this.updateTimer.time
  },




},


 methods: {


clicker(){
  document.getElementById(8).click()

setTimeout(()=>{
  document.getElementById('8.2').click()
  //alert('done')
}, 1000);


    //document.getElementById(8.2).click()


},








 changeSelectObj(item ){  //  нужна для определения типа контента с которого нужно что то спарсить  ну что бы продставить правильно запомненные и результаты процессов
//alert('ok')
   if(item.name == 'Тип объкта'){
     let value = ""
if(item.vModel.value.slice(-1) == 's') {value = item.vModel.value} else {value = item.vModel.value+"s" }

  this.init.forma[3].memoryCounter = this.$store.state.memory[value]
  this.init.forma[3].label = "Использовать запомненные " + this.$store.state.memory[value]
  this.init.forma[3].memoryType =  value
  this.init.forma[2].vModel.contentType =  value
  this.init.forma[0].vModel.contentType =  value
     //item.vModel.value

   }
},


   getMemory(){
     axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/memory/get_counter.php',{
       method: 'POST',
       data: {
            },
     }).then(response => {
        this.$store.state.memory = response.data
    })
   },

 save(){

   axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/proccess_save.php',{
     method: 'POST',
     data: {
       proccessId:  this.proccessId,
       title: this.proccessTitle,
       text:this.proccessText,
       timer:this.procTimer,
          },
   }).then(response => {
      this.toSave = false
      this.sb.snackbar = true
      this.sb.text = 'Процесс успешно сохранен в разделе \"мои процессы\" '
      this.$store.dispatch('changeCounters')
      this.$router.push("/parser/history")
  })
 },




   citySearch () {
   //   alert(this.search)
   this.loading = true
   axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/redirect_vk.php',{
     method: 'POST',
     data: {
       request:"database.getCities?country_id=1&q="+this.search+"&access_token=cc260fce89c84e3e7f33fbd9c508b007f105f29f02906a92f2eacb29c17bb3501b7837f8fb6aa34becbb2&v=5.87"
          },
   }).then(response => {
     this.loading = false
     console.log(response.data)
     this.cities = this.cities.concat(response.data.response.items)
  })
},
   changeForm (newForm,objName,dataType){
     this.clearResult()
     if(newForm){

     this.init.forma = newForm
     this.init.objName = objName   //  тип контента с которого что либо парсится
     this.init.contentMenegment.contentInfo.type = dataType
     this.init.network.dataType = dataType
   } else {

     this.init.forma = this.init.menu.items[0]
     this.init.objName = objName
     this.init.contentMenegment.contentInfo.type = dataType
     this.init.network.dataType = dataType

   }
   },
   clearResult(){
     this.proccessId = null
     this.foundData.displayIds = []
     this.foundData.foundIds = []
     this.foundData.selectedIds = []
     this.foundData.offset = 0
     this.foundData.selector = false
     this.ui.parsing = false

     //axios.post('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/delete_history.php', {process_id:this.proccessId})


   },

sendForm(){
this.ui.parsing = true
let FormParams = ''
let count = ''
let q = ''
let api =  ''
let list = ''   //  для фильтра информации, парсера страниц, парсера обсуждений
let memory = false
let memoryType = ''
let procBinding =  {}
let contentType = ''

this.init.forma.forEach((item,i,arr)=>{
if(item.vkapi  && item.vModel.value !== '' && item.vModel.value){
api = api+'&'+item.vModel.name+'='+item.vModel.value
if(item.vModelCitiesIds  && item.vModelCitiesIds.value !== '' && item.vModelCitiesIds.value){
api = api+'&'+item.vModelCitiesIds.name+'='+item.vModelCitiesIds.value
}}
if( item.vModel.name == 'itemsList'){q  =  item.vModel.value}
if( item.vModel.name == 'count'){ count  =  item.vModel.value}
if( item.dataType == 'FormParams' && item.vModel.value !=='' && item.vModel.value){
if(item.vModel.name == 'postSemantic'){FormParams  = FormParams+'&'+item.vModel.name+'='+JSON.stringify(item.postSemanticParams)}
else if (item.vModel.name == 'descSemantic'){FormParams  = FormParams+'&'+item.vModel.name+'='+JSON.stringify(item.descSemanticParams)}
else {FormParams  = FormParams+'&'+item.vModel.name+'='+item.vModel.value
}}
if( item.dataType == 'list' && item.vModel.value !=='' && item.vModel.value  ){list  =  item.vModel.value}
if( item.dataType == 'memory' && item.vModel.value !=='' && item.vModel.value  ){
memory  =  1
memoryType = item.memoryType
}
if( item.dataType == 'procBinding' ){
procBinding.procResults  =    item.vModel.procResults.selected
procBinding.procUpdates =    item.vModel.procUpdates.selected
}
if( item.type == 'info'  ){
contentType  =    item.vModel.contentType
}
})
FormParams = FormParams.replace(/true/g, '1')
api =   api.replace(/true/g, '1')

//  cтруктура для отправки
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/create_process.php', {
method: 'POST',
data: {
token : this.token,
contentType : contentType ,
processName: this.init.network.processName,
list : list,
memory: memory,
memoryType: memoryType,
procBinding: procBinding,
params: {
vkAPI: {
params: {objType:this.init.objName, itemsList: q, count:count, q:this.q},
api: api,
FormParams: FormParams
}
}
}
})
.then(response => {
this.proccessId = response.data
axios(this.init.network.actionsFile, { method: 'POST',data: {processId: response.data}})
.then(response=>{
this.ui.parsing = false
if(this.foundData.foundIds.length<1){
this.getResults()
}
})
// Получаем информацию по процессу
//this.getResults()
})

},


getResults(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/process_results.php', {method: 'POST',
data: {process_id: this.proccessId}
})
.then(response=>{
//if(this.ui.parsing){this.getResults()}
if(response.data.result_history){
  this.foundData.foundIds = this.foundData.foundIds.concat(response.data.result_history.split(","))
}

}
)
},


},

  mounted(){
  this.getMemory()
  },
  created(){
  this.init.objName =this.init.menu.items[0].objName
  this.init.forma = this.init.menu.items[0].form
  },

 }

</script>

<style>

</style>
